import { useNavigate, useLocation } from 'react-router-dom';
import { useLang } from '../context/LangContext';

export default function MobileBottomNav() {
  const { t } = useLang();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const on = (...paths) => paths.some(p => pathname === p || pathname.startsWith(p + '/')) ? ' on' : '';

  return (
    <div className="mob-bottom-nav">
      <div className="mob-bottom-nav-inner">
        <div className={`mbn-item${on('/')}`} onClick={() => navigate('/')}>
          <span className="mbn-ico">🏠</span><span>{t('mbn.home')}</span>
        </div>
        <div className={`mbn-item${on('/fatwas')}`} onClick={() => navigate('/fatwas')}>
          <span className="mbn-ico">📜</span><span>{t('mbn.fatwa')}</span>
        </div>
        <div className={`mbn-item${on('/scholars')}`} onClick={() => navigate('/scholars')}>
          <span className="mbn-ico">🎓</span><span>{t('mbn.scholars')}</span>
        </div>
        <div className={`mbn-item${on('/research')}`} onClick={() => navigate('/research')}>
          <span className="mbn-ico">📄</span><span>{t('mbn.research')}</span>
        </div>
        <div className={`mbn-item${on('/donate')}`} onClick={() => navigate('/donate')}>
          <span className="mbn-ico">💚</span><span>{t('mbn.donate')}</span>
        </div>
      </div>
    </div>
  );
}
